const STORAGE_KEY = "mantle_utm";
const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
];

// Call once on app load. If the current URL carries UTM params (e.g. from a
// campaign link), stash them so later form submissions can be attributed
// even if the visitor lands on a different page first.
export function captureUtmParams() {
  if (typeof window === "undefined") return;

  const params = new URLSearchParams(window.location.search);
  const found = {};
  UTM_KEYS.forEach((key) => {
    const value = params.get(key);
    if (value) found[key] = value;
  });

  if (Object.keys(found).length > 0) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(found));
    } catch {
      // localStorage unavailable (private mode, etc.) - attribution is
      // best-effort, so just skip it.
    }
  }
}

// Read back whatever campaign params were captured for this visitor, to
// attach to a form submission.
export function getUtmParams() {
  if (typeof window === "undefined") return {};
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}
